import { render } from "./Crcs.vue?vue&type=template&id=96e868c2&scoped=true"
import script from "./Crcs.vue?vue&type=script&lang=js"
export * from "./Crcs.vue?vue&type=script&lang=js"

import "./Crcs.vue?vue&type=style&index=0&id=96e868c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96e868c2"

export default script